import { render } from "./MessageOut.vue?vue&type=template&id=6177e4f5"
import script from "./MessageOut.vue?vue&type=script&lang=js"
export * from "./MessageOut.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/service/service-cp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__